export default __webpack_public_path__ + "static/2-f31d98d0072621c5e04298a8f7485159.png";